function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cab_size_double_long_box_svg__cls-1{fill:#b3b3b3}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cab_size_double_long_box_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cab_size_double_long_box_svg__cls-1",
  d: "M667 401.77a4.6 4.6 0 104.6 4.6 4.57 4.57 0 00-4.6-4.6z",
  transform: "translate(-602 -389)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cab_size_double_long_box_svg__cls-1",
  d: "M676.64 401.1l-.63-.35a7 7 0 00.06-1.12 8.88 8.88 0 00-.34-2.71 2.07 2.07 0 00-1.19-1.19 43.37 43.37 0 00-10.72-1.2h-.91a1.23 1.23 0 01-.85-.24c-1.69-1.19-5.88-4.13-7.84-4.74a11.62 11.62 0 00-2.82-.4c-1.12-.06-5.17-.1-7.07-.13-.27 5-.21 14.23-.18 17.69h16.8v-.35a6.1 6.1 0 1112.19 0v.56h1.82a1 1 0 00.56-.81c2.06-1.85 1.12-5.01 1.12-5.01zm-26.44-3.47h-4.66v-1.26h4.66v1.26zm7.21-3.21a2.84 2.84 0 00.06.62h-12c0-1.53 0-3.35.09-4.49 1.72 0 5 .06 5.83.11a9.6 9.6 0 012.39.34 20.05 20.05 0 014.07 2.49 1 1 0 00-.45.93z",
  transform: "translate(-602 -389)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cab_size_double_long_box_svg__cls-1",
  cx: 17.24,
  cy: 17.36,
  r: 4.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.33 389H640.22a2.67 2.67 0 00-2 .48c-.88.88-1.24 4.07-1.24 5.56h-33.54a22 22 0 00-.28 6.56l-1.16.25a7.62 7.62 0 00.35 2.35 2.36 2.36 0 00.7.31v1.05h10.15a6.09 6.09 0 0112.13.81v.35h18.83c-.04-3.46-.1-12.72.17-17.72zm-2.66 8.6H637v-1.26h4.66v1.26zm1-2.6H639a14.93 14.93 0 01.59-4.08c.15-.43.14-.42.66-.44h2.62c-.11 1.52-.19 3.02-.23 4.52z",
  transform: "translate(-602 -389)",
  fill: "#4d4d4d"
}));

var SvgCabSizeDoubleLongBox = function SvgCabSizeDoubleLongBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cab_size_double_long_box_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 74.85 21.96"
  }, props), _ref, _ref2);
};

export default SvgCabSizeDoubleLongBox;